// extracted by mini-css-extract-plugin
export var adjacentSlide = "_t0-9";
export var arrowButtonContainer = "_t0-5";
export var arrowButtonIcon = "_t0-6";
export var carouselArrowButton = "_t0-2";
export var carouselElementContainer = "_t0-1";
export var currentSlide = "_t0-8";
export var left = "_t0-3";
export var otherSlide = "_t0-a";
export var productCarouselContainer = "_t0-0";
export var right = "_t0-4";
export var sliderOverflow = "_t0-7";